export default __webpack_public_path__ + "static/media/12.13fc30d7.png";